"use strict";

exports.__esModule = true;

// Helper to call a given function, only once
exports.default = function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/_styled-components@2.4.1@styled-components/lib/utils/once.js
// module id = 1936
// module chunks = 0